import React, { useState, useRef, useEffect } from "react"
import {
  Link,
  Element,
  Events,
  animateScroll as scroll,
  scrollSpy,
  scroller,
} from "react-scroll"
import classnames from "classnames"
import { navigate, Link as Gatsbylink } from "gatsby"
import SideMenu from "./../ReportSideMenu"

import Overview from "./../../images/headers/overviewIcon.svg"
import Country from "./../../images/headers/countryIcon.svg"
import Reeg from "./../../images/headers/reeg.svg"
import Predictor from "./../../images/headers/predictorIcon.svg"
import Int from "./../../images/headers/interactionIcon.svg"

function Header({ shortname, menudata, variable }) {
  // global variable used in window.onscroll function
  const [showTitle, setShowTitle] = useState(false)
  const [showSectionNav, setShowSectionNav] = useState(false)
  const [showMenu, setShowMenu] = useState(true)

  const navBar = useRef()
  const writing = useRef()

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (document.documentElement.scrollTop < 50) {
        setShowTitle(false)
        setShowSectionNav(false)
      } else if (
        document.documentElement.scrollTop > 50 &&
        document.documentElement.scrollTop < 100
      ) {
        setShowTitle(true)
        setShowSectionNav(false)
      } else if (document.documentElement.scrollTop > 600) {
        setShowTitle(true)
        setShowSectionNav(true)
      } else if (document.documentElement.scrollTop < 600) {
        // setShowSectionNav(false);
      }
    })
  }, [])

  // Sidebar

  function openSlideMenu() {
    setShowMenu(true)
  }

  function closeSlideMenu() {
    setShowMenu(false)
  }

  return (
    <>
      <nav
        ref={navBar}
        id="someID"
        style={{ background: "null !important" }}
        className={classnames("navbar_report", {
          "with-title": showTitle,
        })}
      >
        {" "}
        <div style={{ marginRight: "10px" }} onClick={openSlideMenu}>
          <i className={classnames("fas fa-bars", { "d-none": showMenu })} />
        </div>
        <div
          className={classnames("sideMenu-bg", {
            show: showMenu,
          })}
        ></div>{" "}
        <div
          style={{
            cursor: "auto",
          }}
          className={classnames("sideMenu", {
            show: showMenu,
          })}
        >
          <div
            className="d-flex"
            style={{
              cursor: "pointer",
              display: "inline-flex",
            }}
          >
            <div
              className="mr-auto p-2"
              style={{
                border: "1px solid #5c5c5c",
                padding: "5px",
                marginTop: "5px",
                color: " #cdcdcd",
              }}
            >
              {" "}
              <Gatsbylink to="/" style={{ color: "#ffffff" }}>
                On
              </Gatsbylink>
            </div>{" "}
            <div
              className="mr-auto p-2"
              style={{
                border: "0 solid #5c5c5c",
                padding: "5px",
                marginTop: "5px",

                color: " #cdcdcd",
              }}
            >
              {" "}
            </div>
            <i className="fas fa-times p-2" onClick={closeSlideMenu}></i>
          </div>{" "}
          <SideMenu
            activeItem={variable}
            items={menudata}
            reverse={false}
            onMenuItemClick={value => navigate("reports/ess/" + value)}
          />
        </div>
        {/* <div
          style={{
            border: "1px solid #5c5c5c",
            padding: "5px",
            color: " #cdcdcd",
          }}
        >
          {" "}
          On
        </div> */}
        <span ref={writing}>
          {/* <Gatsbylink to="/" style={{ color: "#ffffff" }}> */}
          {/* </Gatsbylink> */}
          <span
            style={{
              color: "#919191",
              marginLeft: "35vw",
            }}
          >
            {shortname}
          </span>
        </span>
      </nav>

      <nav
        className={classnames("navbar1", {
          show: showSectionNav,
        })}
      >
        <ul>
          <li className="header">
            <Link
              activeClass="active"
              to="overview"
              spy={true}
              offset={-200}
              smooth={true}
              duration={500}
            >
              <span>
                {" "}
                <Overview
                  fill="#e1e1e1"
                  style={{
                    verticalAlign: "middle",
                    borderStyle: "none",

                    margin: "0 10px 0 4px",
                    height: "20px",
                    width: "20px",
                  }}
                />{" "}
                <p className="header">Overview</p>
              </span>
            </Link>
          </li>
          <li className="header">
            <Link
              activeClass="active"
              to="country"
              spy={true}
              offset={-200}
              smooth={true}
              duration={500}
            >
              {" "}
              <span>
                {" "}
                <Country
                  fill="#e1e1e1"
                  style={{
                    verticalAlign: "middle",
                    borderStyle: "none",

                    margin: "0 10px 0 4px",
                    height: "20px",
                    width: "20px",
                  }}
                />{" "}
                <p className="header">Country</p>
              </span>
            </Link>
          </li>
          <li className="header">
            <Link
              activeClass="active"
              to="regression"
              spy={true}
              offset={-200}
              smooth={true}
              duration={500}
            >
              <span>
                {" "}
                <Reeg
                  fill="#e1e1e1"
                  style={{
                    verticalAlign: "middle",
                    borderStyle: "none",

                    margin: "0 10px 0 4px",
                    height: "20px",
                    width: "20px",
                  }}
                />{" "}
                <p className="header">Regression</p>
              </span>
            </Link>
          </li>
          <li className="header">
            <Link
              activeClass="active"
              to="interaction"
              spy={true}
              offset={-200}
              smooth={true}
              duration={500}
            >
              <span>
                {" "}
                <Int
                  fill="#e1e1e1"
                  style={{
                    verticalAlign: "middle",
                    borderStyle: "none",

                    margin: "0 10px 0 4px",
                    height: "20px",
                    width: "20px",
                  }}
                />{" "}
                <p className="header">Interaction</p>
              </span>
            </Link>
          </li>{" "}
          <li className="header">
            <Link
              activeClass="active"
              to="predictor"
              spy={true}
              offset={-200}
              smooth={true}
              duration={500}
            >
              <span>
                {" "}
                <Predictor
                  fill="#e1e1e1"
                  style={{
                    verticalAlign: "middle",
                    borderStyle: "none",

                    margin: "0 10px 0 4px",
                    height: "20px",
                    width: "20px",
                  }}
                />{" "}
                <p className="header">Key Predictors</p>
              </span>
            </Link>
          </li>
        </ul>
      </nav>
    </>
  )
}

export default Header
